import { render, staticRenderFns } from "./PremiumDialog.vue?vue&type=template&id=46fbe1ce"
import script from "./PremiumDialog.vue?vue&type=script&lang=js"
export * from "./PremiumDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports